import React, { useEffect, useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";

import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

function Header() {
  const history = useHistory();
  const location = useLocation();

  const pageScroll = (e) => {
    history.push("/", { queryParams: { section: e } });
    setTimeout(() => {
      document.getElementById(e).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }, 200);
    setNavExpanded(false);
  };
  const [navExpanded, setNavExpanded] = useState(false);
  const handleNavExpanded = () => setNavExpanded(!navExpanded);
  const closeNav = () => setNavExpanded(false);
  return (
    <>
      <header className="fixed-top">
        <div className="header_v2">
          <div className="container container_frnt">
            <Navbar
              expand="lg"
              bg="dark"
              variant="dark"
              onToggle={handleNavExpanded}
              expanded={navExpanded}
            >
              <Navbar.Brand href="/">
                <img
                  alt="Logo"
                  style={{maxWidth: 300}}
                  src={toAbsoluteUrl("/media/logos/logo-light.svg")}
                />
              </Navbar.Brand>
              <Navbar.Toggle />
              <Navbar.Collapse>
                <Nav className="ml-auto mr-20 lft_nv_v2" onClick={closeNav}>
                  <Link
                    to="/"
                    className={location.pathname === "/" ? "active" : ""}
                  >
                    Home
                  </Link>
                  <Link
                    to="/about-us"
                    className={
                      location.pathname === "/about-us" ? "active" : ""
                    }
                  >
                    About Us
                  </Link>
                  <Link to="" onClick={(e) => pageScroll("Feature")}>
                    Feature
                  </Link>
                  <Link
                    to="/how-it-works"
                    className={
                      location.pathname === "/how-it-works" ? "active" : ""
                    }
                  >
                    How It Works
                  </Link>
                  <Link to="" onClick={(e) => pageScroll("team")}>
                    Our Team
                  </Link>
                  <Link
                    to="/contact-us"
                    className={
                      location.pathname === "/contact-us" ? "active" : ""
                    }
                  >
                    Contact Us
                  </Link>
                </Nav>
                <Nav>
                  <Nav>
                    <Link to="/login" className="lgn_btn_v2 mr-2">
                      Login
                    </Link>
                  </Nav>
                  <Nav>
                    <Link to="/register" className="rgstr_btn_v2">
                      Register Now
                    </Link>
                  </Nav>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
